import { ExamStatus, ExamTemplateIndex, ExamTemplateWithStructureIndex, ExamViewModel } from "../model/Exam";
import { ApiResponse, customFetch } from "./CustomFetch";

export const getExams = (): Promise<ExamTemplateIndex[]> => {
  return customFetch("Exam")
    .then((response) => response.json() as Promise<ApiResponse<ExamTemplateIndex[]>>)
    .then((apiResponse) => apiResponse.data);
};

export const getPublishedExams = (): Promise<ExamTemplateIndex[]> => {
  return customFetch("Exam/published")
    .then((response) => response.json() as Promise<ApiResponse<ExamTemplateIndex[]>>)
    .then((apiResponse) => apiResponse.data);
};

export const getExamsIncludedInPublishedCourses = (): Promise<ExamTemplateWithStructureIndex[]> => {
  return customFetch("Exam/inPublishedCourses")
    .then((response) => response.json() as Promise<ApiResponse<ExamTemplateWithStructureIndex[]>>)
    .then((apiResponse) => apiResponse.data);
};

export const getExam = (examId: string): Promise<ExamViewModel> => {
  return customFetch(`Exam/${examId}`)
    .then((response) => response.json() as Promise<ApiResponse<ExamViewModel>>)
    .then((apiResponse) => apiResponse.data);
};

export const addNewExam = (Exam: ExamViewModel): Promise<ApiResponse<string>> => {
  return customFetch("Exam", {
    body: JSON.stringify(Exam),
    headers: { "Content-Type": "application/json" },
    method: "POST",
  }).then((response) => response.json() as Promise<ApiResponse<string>>);
};

export const updateExam = (exam: ExamViewModel): Promise<Response> => {
  return customFetch("Exam", {
    body: JSON.stringify(exam),
    headers: { "Content-Type": "application/json" },
    method: "PUT",
  });
};

export const publishExam = (exam: ExamViewModel): Promise<Response> => {
  return customFetch(`Exam/status/${exam.id}/${ExamStatus.Published}`, {
    body: JSON.stringify(exam),
    headers: { "Content-Type": "application/json" },
    method: "PUT",
  });
};

export const archiveExam = (exam: ExamViewModel): Promise<Response> => {
  return customFetch(`Exam/status/${exam.id}/${ExamStatus.Archived}`, {
    body: JSON.stringify(exam),
    headers: { "Content-Type": "application/json" },
    method: "PUT",
  });
};

export const deleteExam = (examId: string): Promise<Response> => {
  return customFetch(`Exam/${examId}`, {
    headers: { "Content-Type": "application/json" },
    method: "DELETE",
  });
};
